import styles from './_layout.less';

export default function Layout(props: any) {
  return <div className={styles.setting}>{props.children}</div>;
}
